<p-toolbar styleClass="border-bottom-1 surface-border padding-12">
    <div class="p-toolbar-group-start height-40">
        <p-button
            class="mr-3 border-none"
            icon="pi pi-bars"
            [text]="true"
            [outlined]="true"
            (onClick)="projectService.togglesidebar()"
        ></p-button>
        @if (logoUrl) {
            <span>
                <img
                    [src]="logoUrl"
                    [alphaImageDisplay]="defaultLogoUrl"
                    class="height-40 width-40"
                    [src]="logoUrl"
                    alt="logo"
                />
            </span>
        }
    </div>
    <div class="p-toolbar-group-end gap-4 flex align-items-center">
        <app-languages></app-languages>
        <app-user></app-user>
    </div>
</p-toolbar>
